export default {
      id: "linkedin-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }